import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _ZambdaLogStream_instances, _ZambdaLogStream_baseUrlThunk;
class ZambdaLogStream extends SDKResource {
    constructor(config) {
        super(config);
        _ZambdaLogStream_instances.add(this);
    }
    /**
     * Get the log streams for the Zambda Function with the provided ID. [Zambdas](https://docs.oystehr.com/oystehr/services/zambda/) are functions that can be used to execute your code. They can be used to process data received from Oystehr's APIs or to perform operations on third-party services.
     *
     * Access Policy Action: `Zambda:ReadLogs`
     * Access Policy Resource: `Zambda:Function`
     */
    list(params, request) {
        return this.request('/zambda/{id}/logStream', 'post', __classPrivateFieldGet(this, _ZambdaLogStream_instances, "m", _ZambdaLogStream_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Get all logs for the Zambda Function with the provided ID, filtered by any of: text in messages, minimum start date, and/or maximum end date. [Zambdas](https://docs.oystehr.com/oystehr/services/zambda/) are functions that can be used to execute your code. They can be used to process data received from Oystehr's APIs or to perform operations on third-party services.
     *
     * Access Policy Action: `Zambda:ReadLogs`
     * Access Policy Resource: `Zambda:Function`
     */
    search(params, request) {
        return this.request('/zambda/{id}/logStream/search', 'post', __classPrivateFieldGet(this, _ZambdaLogStream_instances, "m", _ZambdaLogStream_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Get the logs from the specified log stream for the Zambda Function with the provided ID. [Zambdas](https://docs.oystehr.com/oystehr/services/zambda/) are functions that can be used to execute your code. They can be used to process data received from Oystehr's APIs or to perform operations on third-party services.
     *
     * Access Policy Action: `Zambda:ReadLogs`
     * Access Policy Resource: `Zambda:Function`
     */
    get(params, request) {
        return this.request('/zambda/{id}/logStream/{logStreamName}', 'post', __classPrivateFieldGet(this, _ZambdaLogStream_instances, "m", _ZambdaLogStream_baseUrlThunk).bind(this))(params, request);
    }
}
_ZambdaLogStream_instances = new WeakSet(), _ZambdaLogStream_baseUrlThunk = function _ZambdaLogStream_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['projectApiUrl']) !== null && _b !== void 0 ? _b : 'https://project-api.zapehr.com/v1';
};

export { ZambdaLogStream };
//# sourceMappingURL=zambdaLogStream.js.map
